export default __webpack_public_path__ + "great-britain-pound.png";